export default __webpack_public_path__ + "static/media/location_icon1.349ab344.svg";